/**
 * rondo-web-forms
 *
 * Rondo Web Forms
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @license See LICENSE file distributed with this source code.
 */

import React from "react";

import { bem } from "../../../shared/BEM";

/**
 * Component props
 */
export interface IMenuSectionComponentProps {
	grow?: boolean;
	title?: string;
	children?: any;
}

/**
 * Menu section
 *
 * @param props Component props
 */
export function MenuSection(props: IMenuSectionComponentProps) {

	const mods = [];

	if (props.grow) {
		mods.push("grow");
	}

	const stl = bem("menu-section", null, mods);

	return <div className={stl.str}>
		{ props.title ?
		<h2 className={stl.el("title").str}>{props.title}</h2>
		: null }

		<div className={stl.el("content").str}>{props.children}</div>
	</div>;

}
